const RequirePoint = ()=>{
    return <span style={{
        color:'red',
        marginRight:'3px'
    }}>*</span>
}

export default RequirePoint;